import { initializeUnauthedFeatureFlags } from './unauthedFeatureFlag.service';

import { uuidGen } from '@/utils/utils';

const UNAUTHED_UUID_KEY = 'unauthed_uuid';

const getUnauthedUuid = (): string => {
  if (!localStorage.getItem(UNAUTHED_UUID_KEY)) {
    localStorage.setItem(UNAUTHED_UUID_KEY, uuidGen());
  }

  return localStorage.getItem(UNAUTHED_UUID_KEY) as string;
};

export const initUnauthedUserSession = () => {
  const unauthedUuid = getUnauthedUuid();
  window.analytics.track('UnauthedUserSessionInit', { unauthedUuid });
  initializeUnauthedFeatureFlags(unauthedUuid);
};
